import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../services/api';
import arrayCatcher from '../../../../helpers/errorCatcher';

export const getIngredientGroupsListThunk = createAsyncThunk(
  'ingredientGroup/list',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.definitions.ingredientGroups.list();
      const result = response.data.data;
      return result;
    } catch (err: any) {
      arrayCatcher(err?.code);
      return rejectWithValue(err);
    }
  },
);
